package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.FlutterDashW500Rounded: ImageVector
    get() {
        if (_flutterDashW500Rounded != null) {
            return _flutterDashW500Rounded!!
        }
        _flutterDashW500Rounded = Builder(name = "FlutterDashW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(291.65f, 642.57f)
                quadToRelative(-3.0f, -4.06f, 19.86f, -31.98f)
                reflectiveQuadToRelative(52.34f, -59.63f)
                quadToRelative(33.72f, -37.48f, 78.43f, -83.44f)
                quadToRelative(12.0f, -18.0f, 33.72f, -18.24f)
                quadToRelative(21.72f, -0.24f, 35.48f, 16.24f)
                quadToRelative(12.24f, 16.0f, 9.24f, 37.1f)
                reflectiveQuadToRelative(-22.24f, 30.1f)
                quadToRelative(-55.96f, 33.48f, -99.85f, 59.0f)
                quadToRelative(-38.78f, 21.43f, -71.38f, 38.17f)
                quadToRelative(-32.6f, 16.74f, -35.6f, 12.68f)
                close()
                moveTo(428.93f, 927.89f)
                quadToRelative(-5.13f, 0.0f, -10.01f, -2.12f)
                reflectiveQuadToRelative(-8.12f, -7.12f)
                quadToRelative(-4.0f, -6.24f, -8.12f, -16.88f)
                quadToRelative(-4.11f, -10.64f, -4.11f, -24.84f)
                quadToRelative(0.0f, -9.15f, 1.0f, -16.79f)
                quadToRelative(1.0f, -7.63f, 3.0f, -15.77f)
                quadToRelative(-27.46f, -5.09f, -46.33f, -27.48f)
                quadToRelative(-18.87f, -22.39f, -18.87f, -51.94f)
                quadToRelative(0.0f, -4.08f, 3.0f, -21.41f)
                quadToRelative(-75.2f, -26.71f, -121.53f, -84.55f)
                quadToRelative(-46.34f, -57.84f, -59.58f, -149.51f)
                quadToRelative(-5.24f, 5.24f, -11.31f, 8.12f)
                quadToRelative(-6.07f, 2.88f, -14.17f, 2.88f)
                quadToRelative(-15.48f, 0.0f, -38.33f, -22.9f)
                quadToRelative(-22.86f, -22.9f, -22.86f, -99.23f)
                quadToRelative(0.0f, -70.22f, 41.3f, -126.8f)
                quadToRelative(41.3f, -56.57f, 81.07f, -56.57f)
                quadToRelative(13.26f, 0.0f, 16.76f, 11.86f)
                quadToRelative(3.5f, 11.86f, 3.5f, 22.86f)
                quadToRelative(38.95f, -54.72f, 97.29f, -90.44f)
                reflectiveQuadToRelative(128.77f, -43.96f)
                quadToRelative(6.24f, -29.47f, 29.62f, -46.33f)
                quadToRelative(23.39f, -16.86f, 49.82f, -16.86f)
                verticalLineToRelative(40.72f)
                quadToRelative(4.0f, -6.0f, 10.24f, -10.24f)
                quadToRelative(5.0f, -3.76f, 12.65f, -6.88f)
                reflectiveQuadToRelative(17.86f, -3.12f)
                quadToRelative(10.2f, 0.0f, 17.82f, 3.12f)
                quadToRelative(7.62f, 3.12f, 12.62f, 6.88f)
                quadToRelative(6.24f, 4.24f, 10.24f, 10.24f)
                quadToRelative(-15.48f, 0.0f, -25.48f, 9.12f)
                reflectiveQuadToRelative(-13.24f, 22.35f)
                quadToRelative(54.96f, 14.48f, 101.8f, 46.96f)
                quadToRelative(46.84f, 32.48f, 79.55f, 78.44f)
                quadToRelative(0.0f, -11.0f, 3.56f, -22.86f)
                reflectiveQuadToRelative(16.77f, -11.86f)
                quadToRelative(39.63f, 0.0f, 80.97f, 56.54f)
                quadToRelative(41.33f, 56.54f, 41.33f, 126.83f)
                quadToRelative(0.0f, 76.41f, -22.86f, 99.27f)
                quadToRelative(-22.85f, 22.86f, -38.34f, 22.86f)
                quadToRelative(-7.23f, 0.0f, -13.73f, -2.5f)
                reflectiveQuadToRelative(-11.5f, -7.5f)
                quadToRelative(-14.48f, 101.67f, -69.96f, 162.3f)
                quadToRelative(-55.48f, 60.62f, -147.11f, 81.0f)
                quadToRelative(3.24f, 14.24f, 13.74f, 22.86f)
                reflectiveQuadToRelative(24.98f, 8.62f)
                horizontalLineToRelative(23.24f)
                quadToRelative(7.21f, 0.0f, 12.36f, 4.06f)
                quadToRelative(5.15f, 4.07f, 7.21f, 10.16f)
                quadToRelative(5.15f, 16.26f, 17.89f, 30.5f)
                quadToRelative(12.74f, 14.24f, 23.74f, 23.64f)
                quadToRelative(8.0f, 7.31f, 7.61f, 16.81f)
                quadToRelative(-0.38f, 9.5f, -8.61f, 14.74f)
                quadToRelative(-11.0f, 8.0f, -28.44f, 14.11f)
                quadToRelative(-17.43f, 6.1f, -45.11f, 8.13f)
                quadToRelative(-5.13f, 0.0f, -10.01f, -2.0f)
                reflectiveQuadToRelative(-8.12f, -7.0f)
                quadToRelative(-4.0f, -6.24f, -8.12f, -16.91f)
                quadToRelative(-4.12f, -10.67f, -4.12f, -24.9f)
                quadToRelative(0.0f, -9.14f, 1.0f, -16.88f)
                quadToRelative(1.0f, -7.74f, 3.0f, -15.74f)
                quadToRelative(-24.48f, -5.0f, -41.22f, -22.24f)
                quadToRelative(-16.73f, -17.24f, -21.82f, -40.72f)
                quadToRelative(-15.27f, 2.0f, -30.54f, 3.0f)
                reflectiveQuadToRelative(-32.58f, 1.0f)
                quadToRelative(-26.47f, 0.0f, -51.57f, -2.62f)
                quadToRelative(-25.09f, -2.62f, -48.31f, -7.62f)
                lineToRelative(-2.02f, 10.24f)
                quadToRelative(0.0f, 17.31f, 11.73f, 29.01f)
                quadToRelative(11.74f, 11.71f, 29.09f, 11.71f)
                horizontalLineToRelative(23.47f)
                quadToRelative(7.14f, 0.0f, 12.14f, 4.07f)
                quadToRelative(5.0f, 4.07f, 7.0f, 10.17f)
                quadToRelative(5.16f, 16.17f, 18.06f, 30.32f)
                quadToRelative(12.9f, 14.16f, 23.9f, 23.56f)
                quadToRelative(8.0f, 7.31f, 7.62f, 16.81f)
                quadToRelative(-0.38f, 9.5f, -8.62f, 14.74f)
                quadToRelative(-11.0f, 8.0f, -28.43f, 14.21f)
                quadToRelative(-17.43f, 6.2f, -45.12f, 8.27f)
                close()
                moveTo(755.02f, 529.72f)
                quadToRelative(5.0f, -20.45f, 7.5f, -42.94f)
                quadToRelative(2.5f, -22.5f, 2.5f, -47.74f)
                quadToRelative(0.0f, -118.08f, -83.48f, -201.55f)
                quadToRelative(-83.49f, -83.47f, -201.59f, -83.47f)
                quadToRelative(-118.1f, 0.0f, -201.54f, 83.49f)
                quadToRelative(-83.43f, 83.5f, -83.43f, 201.61f)
                quadToRelative(0.0f, 24.43f, 2.5f, 46.83f)
                reflectiveQuadToRelative(7.5f, 42.77f)
                quadToRelative(5.24f, -20.48f, 13.86f, -40.22f)
                reflectiveQuadToRelative(19.86f, -37.26f)
                quadToRelative(-6.0f, -14.44f, -9.62f, -30.17f)
                quadToRelative(-3.62f, -15.73f, -3.62f, -32.99f)
                quadToRelative(0.0f, -63.95f, 44.33f, -108.29f)
                quadToRelative(44.34f, -44.33f, 108.32f, -44.33f)
                quadToRelative(29.46f, 0.0f, 55.55f, 10.62f)
                quadToRelative(26.1f, 10.62f, 46.34f, 29.09f)
                quadToRelative(20.24f, -18.47f, 46.34f, -29.09f)
                quadToRelative(26.09f, -10.62f, 55.55f, -10.62f)
                quadToRelative(63.98f, 0.0f, 108.32f, 44.33f)
                quadToRelative(44.33f, 44.34f, 44.33f, 108.29f)
                quadToRelative(0.0f, 17.26f, -3.5f, 32.99f)
                reflectiveQuadToRelative(-10.74f, 30.21f)
                quadToRelative(11.24f, 17.48f, 20.36f, 37.22f)
                reflectiveQuadToRelative(14.36f, 41.22f)
                close()
                moveTo(480.11f, 724.3f)
                quadToRelative(88.57f, 0.0f, 149.14f, -27.59f)
                quadToRelative(60.58f, -27.6f, 94.04f, -82.54f)
                quadToRelative(0.0f, -3.06f, 0.51f, -6.11f)
                quadToRelative(0.5f, -3.05f, 0.5f, -6.1f)
                quadToRelative(0.0f, -30.53f, -7.12f, -59.12f)
                quadToRelative(-7.11f, -28.6f, -21.35f, -53.84f)
                quadToRelative(-21.48f, 23.48f, -50.34f, 37.72f)
                quadToRelative(-28.86f, 14.24f, -63.66f, 14.24f)
                quadToRelative(-8.19f, 0.0f, -16.38f, -1.03f)
                quadToRelative(-8.18f, -1.02f, -16.25f, -3.06f)
                quadToRelative(5.0f, -7.15f, 7.62f, -14.65f)
                quadToRelative(2.61f, -7.5f, 3.61f, -15.74f)
                quadToRelative(1.0f, -2.24f, 1.0f, -4.24f)
                verticalLineToRelative(-4.0f)
                quadToRelative(5.12f, 1.0f, 10.24f, 1.5f)
                reflectiveQuadToRelative(10.24f, 0.5f)
                quadToRelative(46.96f, 0.0f, 79.44f, -32.64f)
                reflectiveQuadToRelative(32.48f, -79.55f)
                quadToRelative(0.0f, -46.92f, -32.48f, -79.4f)
                quadToRelative(-32.48f, -32.48f, -79.48f, -32.48f)
                quadToRelative(-20.44f, 0.0f, -39.67f, 7.5f)
                quadToRelative(-19.24f, 7.5f, -34.72f, 21.98f)
                lineTo(480.0f, 330.13f)
                lineToRelative(-27.48f, -24.48f)
                quadToRelative(-15.48f, -14.48f, -34.72f, -21.98f)
                quadToRelative(-19.23f, -7.5f, -39.67f, -7.5f)
                quadToRelative(-47.0f, 0.0f, -79.48f, 32.48f)
                quadToRelative(-32.48f, 32.48f, -32.48f, 79.37f)
                quadToRelative(0.0f, 41.78f, 25.86f, 72.0f)
                reflectiveQuadToRelative(64.82f, 38.22f)
                lineToRelative(-30.48f, 33.48f)
                quadToRelative(-18.48f, -7.24f, -34.22f, -17.74f)
                quadToRelative(-15.74f, -10.5f, -27.98f, -24.98f)
                quadToRelative(-14.24f, 25.24f, -21.35f, 53.78f)
                quadToRelative(-7.12f, 28.55f, -7.12f, 59.13f)
                verticalLineToRelative(10.2f)
                quadToRelative(34.63f, 55.08f, 95.75f, 83.64f)
                quadToRelative(61.12f, 28.55f, 148.66f, 28.55f)
                close()
                moveTo(538.7f, 438.66f)
                quadToRelative(-17.98f, -20.86f, -17.98f, -50.57f)
                quadToRelative(0.0f, -29.72f, 17.98f, -50.46f)
                quadToRelative(17.97f, -20.74f, 43.21f, -20.74f)
                quadToRelative(25.24f, 0.0f, 43.1f, 20.74f)
                quadToRelative(17.86f, 20.74f, 17.86f, 50.46f)
                quadToRelative(0.0f, 29.71f, -17.86f, 50.57f)
                reflectiveQuadToRelative(-43.1f, 20.86f)
                quadToRelative(-25.24f, 0.0f, -43.21f, -20.86f)
                close()
                moveTo(597.08f, 367.85f)
                quadToRelative(7.07f, 0.0f, 11.31f, -4.66f)
                quadToRelative(4.24f, -4.65f, 4.24f, -10.85f)
                quadToRelative(0.0f, -6.21f, -4.61f, -10.71f)
                quadToRelative(-4.6f, -4.5f, -10.75f, -4.5f)
                quadToRelative(-7.17f, 0.0f, -11.26f, 4.5f)
                quadToRelative(-4.1f, 4.5f, -4.1f, 10.74f)
                quadToRelative(0.0f, 7.0f, 4.55f, 11.24f)
                reflectiveQuadToRelative(10.62f, 4.24f)
                close()
                moveTo(334.99f, 438.66f)
                quadToRelative(-17.86f, -20.86f, -17.86f, -50.57f)
                quadToRelative(0.0f, -29.72f, 17.86f, -50.46f)
                quadToRelative(17.86f, -20.74f, 43.1f, -20.74f)
                quadToRelative(25.24f, 0.0f, 43.21f, 20.74f)
                quadToRelative(17.98f, 20.74f, 17.98f, 50.46f)
                quadToRelative(0.0f, 29.71f, -17.98f, 50.57f)
                quadToRelative(-17.97f, 20.86f, -43.21f, 20.86f)
                quadToRelative(-25.24f, 0.0f, -43.1f, -20.86f)
                close()
                moveTo(393.57f, 367.85f)
                quadToRelative(7.11f, 0.0f, 11.17f, -4.66f)
                quadToRelative(4.06f, -4.65f, 4.06f, -10.85f)
                quadToRelative(0.0f, -6.21f, -4.54f, -10.71f)
                quadToRelative(-4.55f, -4.5f, -10.62f, -4.5f)
                quadToRelative(-7.07f, 0.0f, -11.31f, 4.55f)
                reflectiveQuadToRelative(-4.24f, 10.61f)
                quadToRelative(0.0f, 7.08f, 4.64f, 11.32f)
                reflectiveQuadToRelative(10.84f, 4.24f)
                close()
            }
        }
        .build()
        return _flutterDashW500Rounded!!
    }

private var _flutterDashW500Rounded: ImageVector? = null
